import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, initializing } = useAuthStore();
  const location = useLocation();

  if (initializing) {
    return <div />; // or splash screen
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}